import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { accountLedgerActions } from '../actions/account-ledger.actions';
import { IAccountLedgerPage, ILedgerRowWire } from '../models/account-ledger.model';
import {
    selectAccountLedgerCanLoadMore,
    selectAccountLedgerCursor,
    selectAccountLedgerError,
    selectAccountLedgerLoading,
    selectAccountLedgerLoadingMore,
    selectAccountLedgerPage,
    selectAccountLedgerRows,
} from '../selectors/account-ledger.selectors';

/** The door through which the account page reaches its Kontenblatt. */
@Injectable()
export class AccountLedgerProvider {
    public constructor(private readonly store: Store) {}

    public page$(): Observable<Omit<IAccountLedgerPage, 'rows'> | null> {
        return this.store.select(selectAccountLedgerPage);
    }

    public rows$(): Observable<ILedgerRowWire[]> {
        return this.store.select(selectAccountLedgerRows);
    }

    public loading$(): Observable<boolean> {
        return this.store.select(selectAccountLedgerLoading);
    }

    public loadingMore$(): Observable<boolean> {
        return this.store.select(selectAccountLedgerLoadingMore);
    }

    public error$(): Observable<string | null> {
        return this.store.select(selectAccountLedgerError);
    }

    public cursor$(): Observable<string | null> {
        return this.store.select(selectAccountLedgerCursor);
    }

    public canLoadMore$(): Observable<boolean> {
        return this.store.select(selectAccountLedgerCanLoadMore);
    }

    public load(projectId: string, accountId: string): void {
        this.store.dispatch(accountLedgerActions.load({ projectId, accountId }));
    }

    public loadMore(projectId: string, accountId: string, cursor: string): void {
        this.store.dispatch(accountLedgerActions.loadMore({ projectId, accountId, cursor }));
    }
}
